var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "24px",
    viewBox: "0 0 14.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,4174 L0,4174 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1237243,0 L10.1237243,1.60139766 L13.5,1.59978498 L13.5,24 L0,24 L0,1.59978498 L3.37457478,1.59978498 L3.37457478,0 L10.1237243,0 Z M11.8127126,3.19956995 L1.68558649,3.19956995 L1.68558649,22.3986023 L11.8127126,22.3986023 L11.8127126,3.19956995 Z M9.21884843,6.3991399 L6.2967116,11.1984948 L10.1220234,11.1984948 L5.06186216,19.5118936 L5.06186216,16.3107109 L7.2015875,12.7982798 L3.37457478,12.7982798 L7.26962328,6.3991399 L9.21884843,6.3991399 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-714.0 -1296.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.0 1264.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.0 32.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13.5,0 13.5,24 0,24 0,0",
    stroke: "none",
    fill: "#000000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryCharging);
export default __webpack_public_path__ + "static/media/BatteryCharging.9976335b952776010023581b5112393b.svg";
export { ForwardRef as ReactComponent };